import { render, staticRenderFns } from "./groupbuy_company_page.vue?vue&type=template&id=c2211238&scoped=true"
import script from "./groupbuy_company_page.vue?vue&type=script&lang=js"
export * from "./groupbuy_company_page.vue?vue&type=script&lang=js"
import style0 from "./groupbuy_company_page.vue?vue&type=style&index=0&id=c2211238&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2211238",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2211238')) {
      api.createRecord('c2211238', component.options)
    } else {
      api.reload('c2211238', component.options)
    }
    module.hot.accept("./groupbuy_company_page.vue?vue&type=template&id=c2211238&scoped=true", function () {
      api.rerender('c2211238', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/group_buy/company/groupbuy_company_page.vue"
export default component.exports